import { config } from 'public/styles';

export const getSelfieStepSettings = (): Record<string, unknown> => {
  return {
    startScreen: true,
    finishScreen: true,
    changeCamera: true,
    customization: {
      retryScreenRetryButtonBackground: config.colors.primary,
      retryScreenRetryButtonBackgroundHover: config.colors.primary,
      retryScreenRetryButtonTitle: config.colors.text.primary,
      retryScreenRetryButtonTitleHover: config.colors.text.primary,
      onboardingScreenStartButtonTitle: config.colors.text.primary,
      onboardingScreenStartButtonBackground: config.colors.primary,
      onboardingScreenStartButtonBackgroundHover: config.colors.primary,
      onboardingScreenStartButtonTitleHover: config.colors.text.primary,
      cameraScreenStrokeNormal: config.colors.primary,
      processingScreenProgress: config.colors.primary,
    },
    closeDisabled: true,
    copyright: false,
  };
};
